import type { MakeRouteMatchUnion } from '@tanstack/react-router';
import type { Mode } from '@listening/env/repo-wide-config';

const routesHiddenInProduction = new Set<string>([
  '/text-to-speech-app-comparison',
] satisfies Array<MakeRouteMatchUnion['fullPath']>);

const withoutTrailingSlash = (path: string) =>
  path.length > 1 ? path.replace(/\/$/, '') : path;

export function isRouteEnabled(path: string, mode: Mode) {
  return (
    mode !== 'production' ||
    !routesHiddenInProduction.has(withoutTrailingSlash(path))
  );
}
